var _rect, _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666,
    y: 40,
    width: 40,
    height: 40,
    rx: 5,
    transform: "rotate(-90 .666 40)",
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.166 14.75a4.667 4.667 0 0 1 4.667-4.666h11.666a4.667 4.667 0 0 1 4.667 4.667V27a4.667 4.667 0 0 1-4.667 4.666H14.833a4.667 4.667 0 0 1-4.667-4.666V14.75z",
    fill: "#192440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 10.084H14.832a4.667 4.667 0 0 0-4.667 4.667v1.75h21v-1.75a4.667 4.667 0 0 0-4.667-4.667z",
    fill: "#192440"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.459c.483 0 .875.392.875.875v3.5a.875.875 0 0 1-1.75 0v-3.5c0-.483.392-.875.875-.875zm9.333 0c.484 0 .875.392.875.875v3.5a.875.875 0 1 1-1.75 0v-3.5c0-.483.392-.875.875-.875z",
    fill: "#192440"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.667,
    cy: 23.501,
    fill: "#192440",
    r: 1.167
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.333,
    cy: 23.501,
    fill: "#192440",
    r: 1.167
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.999,
    cy: 23.501,
    fill: "#192440",
    r: 1.167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkupload);
export default __webpack_public_path__ + "static/media/bulkupload.28651500e1169d4295a882e01a307e22.svg";
export { ForwardRef as ReactComponent };